import { Injectable } from "@angular/core";
import { Observable, Subject } from "rxjs";

@Injectable()
export class PasswordProtectionService
{
  private _confirm: Subject<string> = new Subject<string>();
  confirm$: Observable<string> = this._confirm.asObservable();

  confirm(password: string): void
  {
    this._confirm.next(password);
  }
}